<script setup lang="ts">
import ICarbonChevronLeft from '~icons/carbon/chevron-left'
import ICarbonClose from '~icons/carbon/close'
import type { PropType } from 'vue'
import type { UnionFromTuple } from '@oen.web.vue/utils'
import { analyticsNameProp } from '../common/props'
import OenUiButton from '../OenUiButton/OenUiButton.vue'
import { icons } from './variants'

type IconString = UnionFromTuple<typeof icons>
defineProps({
  icon: {
    type: String as PropType<IconString>,
    default: icons[0],
    validator: (icon: (typeof icons)[number]) => icons.includes(icon),
  },
  name: {
    type: String,
    default: 'Close',
  },
  ...analyticsNameProp,
})

interface Emit {
  (e: 'click'): void
}

const emit = defineEmits(["click"])
</script>

<template>
  <OenUiButton :analytics-name="analyticsName" theme="icon" @click="emit('click')">
    <ICarbonChevronLeft v-if="icon === icons[1]" :title="name" class="rtl:rotate-180" />
    <ICarbonClose v-else class="text-3xl" :title="name" />
  </OenUiButton>
</template>
